export default __webpack_public_path__ + "media/Slice.e4d9bf59.png";